import { AnyInterior } from "../types";
import AdminMpProvider from "@/core/data-provider/data-mp/admin/admin-mp-provider";
import copyText from "@/core/helpers/copyText";
import { Button } from "@/shared/ui";
import toast from "@/domains/toasts/helpers/toast";

type CreateEntityInteriorListItemProps = {
  interior: AnyInterior;
};

export default function CreateEntityInteriorListItem({
  interior,
}: CreateEntityInteriorListItemProps) {
  return (
    <div key={interior.uuid} className="bg-dark-800 rounded-lg p-4">
      <div className="flex items-start justify-between">
        <div className="flex-1 space-y-3">
          <div>
            <h3 className="text-16 font-semibold text-white mb-1 flex justify-between items-center gap-2">
              {interior.name}

              <Button
                variant="surface"
                className="h-8 px-3 text-xs"
                onClick={() => {
                  copyText(interior.uuid);
                  toast.success("UUID скопирован в буфер обмена");
                }}
              >
                UUID
              </Button>
            </h3>
            <p className="text-sm text-white/60 leading-relaxed">
              {interior.description || "Описание отсутствует"}
            </p>
          </div>

          <Button
            variant="surface"
            className="h-8 px-3 text-xs"
            onClick={() => {
              AdminMpProvider.teleportByCoords(interior.position);
            }}
          >
            Телепорт
          </Button>

          <details className="group">
            <summary className="text-sm text-white/70 cursor-pointer hover:text-white/90 transition-colors font-medium">
              Дамп точек
            </summary>

            <div className="mt-3 p-3 bg-black/20 rounded border border-white/10">
              <pre className="text-xs text-white/80 font-mono overflow-x-auto">
                {JSON.stringify(interior.content, null, 2)}
              </pre>
            </div>
          </details>
        </div>
      </div>
    </div>
  );
}
